export enum ThreatRatingColor {
  Low = '#87C089',
  Medium = '#D0EDD0',
  High = '#F3E37B',
  VeryHigh = '#D28480',
  NotApplicable = '#959393',
  NotSpecified = 'transparent',
}
